import { Pipe, PipeTransform } from '@angular/core';

export const defaultTruncateLimit = 60;

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  constructor() {}

  public transform(value: string, limit: number = defaultTruncateLimit): string {
    return value.length <= limit ? value : `${value.substr(0, limit)}...`;
  }
}
